export const header_cn = {
  ViewMore: '查看更多',
  SignIn: '登录',
  SignOut: '退出',
  BackOld: '返回经典版',
  Dashboard: '控制台',
  JoinUs: '成为会员',
  inquiry: {
    inquiry_board: '询盘大厅',
    find_agent: '找代理',
    freight_forwarding: '货代圈',
    post_inquiry: '发布询盘',
  },
  cooperativeGuarantee: {
    cooperative_guarantee: '合作保障',
    cooperative_guarantee_desc:
      '会员合作风险保障、提供行业领先的纠纷处理方案，为你全方位保驾护航。',
    risk_member_list: '风险名单',
    risk_member_list_desc: '线上黑名单全员同步预警，将风险合作拒之门外。',
    online_claim: '线上申诉',
    online_claim_desc: '申诉、纠纷线上受理，受理流程时时掌握。',
    risk_prevention: '风险预防',
    risk_prevention_desc: '案例分享、风控通知、避坑指南，防患于未然。',
    assurance_introduction: '规则介绍',
    assurance_introduction_desc:
      '平台规则公开透明、处理流程一目了然，把握自身保障的权益。',
  },
  financialPayment: {
    financial_payment: '金融支付',
    financial_payment_desc: '高效安全的结算服务，一年节省上万元手续费',

    jc_pay: '全球会员间免费结算',
    jc_pay_desc:
      '无银行手续费，资金即时到账，为了保护您的资金安全，推荐您和会员间在平台内结算',

    usd_payment: '国内在线收付海运费',
    usd_payment_desc:
      '联合中国银行推出的收付海运费秒到服务,为货代提升结算效率提供更优选择',

    tcs: '跨境收付汇安全省钱',
    tcs_desc: '为超过6000家企业提供在线跨境收付汇服务，汇率和手续费均低于银行',
  },
}
export const header_en = {
  ViewMore: 'View More',
  SignIn: 'SIGN IN',
  SignOut: 'SIGN OUT',
  BackOld: 'Back To Classic',
  Dashboard: 'Dashboard',
  JoinUs: 'Become a Member',
  inquiry: {
    inquiry_board: 'Inquiry Board',
    find_agent: 'Find Agent',
    freight_forwarding: '货代圈',
    post_inquiry: 'Post Inquiry',
  },
  cooperativeGuarantee: {
    cooperative_guarantee: 'Cooperation Risk Protection',
    cooperative_guarantee_desc:
      'Comprehensive cooperation risk protection and professional dispute resolution services for your complete peace of mind',

    risk_member_list: 'Risk Member list',
    risk_member_list_desc:
      'Assist members in effectively managing business risks and mitigating their impact.',
    online_claim: 'Online Claim',
    online_claim_desc:
      'Claim and disputes are accepted online and with real-time updates on the acceptance process.',
    risk_prevention: 'Risk Prevention',
    risk_prevention_desc:
      'Share case studies and risk control notices to stay informed about risks and safeguard your business.',
    assurance_introduction: 'Assurance Introduction',
    assurance_introduction_desc:
      'The protection rules are open and transparent, and the processing process is very clear, so that every protection is not missed.',
  },

  financialPayment: {
    financial_payment: 'Financial Payment',
    financial_payment_desc:
      'Efficient and safe settlement services, saving thousands of dollars in payment fees per year',

    jc_pay: 'Settlement between members without any fees',
    jc_pay_desc:
      'Receive and pay in real-time without transaction fees. We encourage you to make payment through platform to protect the safety of your payment.',

    usd_payment: '国内在线收付海运费',
    usd_payment_desc:
      '联合中国银行推出的收付海运费秒到服务,为货代提升结算效率提供更优选择 ',

    tcs: 'Collect money from your Chinese partner cheap and fast',
    tcs_desc:
      'Help more than 6,000 companies to collect money from their Chinese agnets. Lower exchange rates and fees.',
  },
}

export const footer_cn = {}
export const footer_en = {}
